<template>
  <div
    id="employee"
    class="mobile:mt-[80px] mt-desktop:mt-[120px] block flex-col"
  >
    <div
      class="mobile:text-[32px] text-white tablet:text-[48px] font-bold text-center"
    >
      Команда
    </div>
    <div class="flex gap-4 mt-10">
      <div
        @click="prevSlide"
        class="flex cursor-pointer items-center justify-center h-13 w-13 bg-white rounded-full"
      >
        <img class="w-6 h-6" src="@/assets/icons/chevron-left.svg" alt="" />
      </div>
      <div
        @click="nextSlide"
        class="flex cursor-pointer items-center justify-center h-13 w-13 bg-white rounded-full"
      >
        <img class="w-6 h-6" src="@/assets/icons/chevron-right.svg" alt="" />
      </div>
    </div>
    <swiper
      :slides-per-view="4"
      :space-between="50"
      class="max-w-[100%] client-slider mt-15 flex items-start"
      @swiper="onSwiper"
      loop
      :breakpoints="{
        1240: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
      }"
      ref="platform"
      @slideChange="onSlideChange"
    >
      <swiper-slide
        v-for="(slide, i) in employee_list"
        :key="i"
        class="flex flex-col justify-center items-center w-full"
      >
        <img :src="slide.src" alt="" class="rounded-xl" />
        <div class="flex flex-col items-center gap-2 mt-10">
          <div class="mobile:text-md text-center tablet:text-2xl font-medium">
            {{ slide.name }}
          </div>
          <div
            class="mobile:text-sm tablet:text-lg text-center font-medium text-white/60"
          >
            {{ slide.post }}
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { employee_list } from "@/collection/employee";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

const employeeSlider = ref(null),
  onSwiper = (swiper) => {
    employeeSlider.value = swiper;
  },
  onSlideChange = () => {
    console.log("slide change");
  },
  prevSlide = () => {
    employeeSlider.value.slidePrev();
  },
  nextSlide = () => {
    employeeSlider.value.slideNext();
  };
</script>

<style lang="scss">
.client-slider {
  .swiper-wrapper {
    display: flex;
    align-items: flex-start;
  }
}
</style>
